"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  NewspaperFold: ['newspaper-fold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,6V20.25a2.25,2.25,0,0,1-4.5,0V3a1.5,1.5,0,0,0-1.5-1.5h-15A1.5,1.5,0,0,0,.75,3V20.25A2.25,2.25,0,0,0,3,22.5H21', 'M4.5 15L15 15', 'M4.5 18L10.5 18', 'M4.500 5.250 L15.000 5.250 L15.000 11.250 L4.500 11.250 Z']],
  NewspaperRead: ['newspaper-read', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.625 4.125 A3.375 3.375 0 1 0 15.375 4.125 A3.375 3.375 0 1 0 8.625 4.125 Z', 'M14.92,9.75a6.059,6.059,0,0,0-5.84,0', 'M12,23.25s3.514-3.126,6.986-3.479A1.464,1.464,0,0,0,20.25,18.29V12.762a1.471,1.471,0,0,0-1.625-1.5c-3.259.364-6.625,3.01-6.625,3.01s-3.366-2.646-6.625-3.01a1.471,1.471,0,0,0-1.625,1.5V18.29a1.464,1.464,0,0,0,1.264,1.481C8.485,20.124,12,23.25,12,23.25Z', 'M12 14.269L12 23.247']],
  NewspaperReadMan: ['newspaper-read-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.781,6.5c-4.428.731-5.417-.257-6.406-1.251C11.386,6.24,10.4,7.228,5.968,6.5', 'M18.057,9.679l.718-3.225A4.5,4.5,0,0,0,15.555,1.1,12.9,12.9,0,0,0,12.375.75,12.9,12.9,0,0,0,9.2,1.1a4.5,4.5,0,0,0-3.22,5.356l.718,3.225', 'M4.875,19.241v1.011a.9.9,0,0,0,.589.886l6.911,2.112V14.417L5.9,12.043a.818.818,0,0,0-1.027.874v1.836', 'M19.888,19.094v1.158a.9.9,0,0,1-.588.886L12.375,23.25V14.417l6.486-2.374a.818.818,0,0,1,1.027.874v1.99', 'M6.362,18.356c0,.5-.563.9-1.251.894-1.378-.006-2.491-.817-2.486-1.81l0-.9c0-.994,1.125-1.794,2.5-1.788.689,0,1.245.409,1.243.906Z', 'M17.632,18.356c0,.5.563.9,1.253.894,1.38-.006,2.495-.817,2.49-1.81l0-.9c0-.994-1.127-1.794-2.507-1.788-.689,0-1.247.409-1.244.906Z', 'M10.125 9.75L10.125 10.5', 'M14.625 9.75L14.625 10.5']],
  NewspaperGive: ['newspaper-give', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,15.75H4.629a3.023,3.023,0,0,1,2.121.879L10.125,20l2.625-2.625A1.5,1.5,0,0,1,14.871,19.5l-2.625,2.625a3,3,0,0,1-4.242,0L5.25,19.5v3.75', 'M.75,12.675a3.75,3.75,0,1,0,0-7.35', 'M15.75,14.25V2.641S14.113.823,8.6.75a.336.336,0,0,0-.243.1.349.349,0,0,0-.1.246V12.013a.344.344,0,0,0,.336.346c5.526.071,7.164,1.891,7.164,1.891', 'M15.75,14.25V2.641S17.387.823,22.905.75a.336.336,0,0,1,.243.1.349.349,0,0,1,.1.246V12.013a.344.344,0,0,1-.336.346c-5.526.071-7.164,1.891-7.164,1.891']],
  Newspaper: ['newspaper', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M13.5 13.5L19.5 13.5', 'M13.5 16.5L19.5 16.5', 'M13.5 19.5L17.25 19.5', 'M3.75 13.5L9.75 13.5', 'M3.75 16.5L9.75 16.5', 'M3.75 19.5L7.5 19.5', 'M3.750 3.750 L20.250 3.750 L20.250 9.750 L3.750 9.750 Z']]
};
exports["default"] = _default;